import React from "react";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircle from "@mui/icons-material/RemoveCircle";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Tooltip } from "@mui/material";

import { RemediationType } from "@/pages/browser-defender/demo/passwordMisuseUpdated/service/types";

export const getRemediationIcon = (
  t: (key: string) => string,
  remediation?: RemediationType,
) => {
  switch (remediation) {
    case "safe":
      return (
        <Tooltip
          title={t("Browsing and password reuse are both allowed")}
          arrow
        >
          <CheckCircleIcon
            sx={{
              color: "#4CAF50",
              fontSize: 20,
            }}
          />
        </Tooltip>
      );
    case "reuse":
      return (
        <Tooltip
          title={t("Browsing is allowed but password reuse is prohibited")}
          arrow
        >
          <ReportProblemIcon
            sx={{
              color: "#FFA500",
              fontSize: 20,
            }}
          />
        </Tooltip>
      );
    case "blocked":
      return (
        <Tooltip title={t("Browsing is blocked")} arrow>
          <RemoveCircle
            sx={{
              color: "#F44336",
              fontSize: 20,
            }}
          />
        </Tooltip>
      );
    default:
      return null;
  }
};
